import { call, put, select } from "redux-saga/effects";
import api from "../../services/api";
import { Creators as ErrorActions } from "../ducks/error";
import { Creators as AtendimentoActions } from "../ducks/atendimento";
import { Creators as BuscaClienteActions } from "../ducks/buscaCliente";
import { Creators as AgendamentosActions } from "../ducks/agendamentos";
import { Creators as SuccessActions } from "../ducks/success";
import { Creators as LoadingActions } from "../ducks/loading";

export function* getAtendimento() {
  try {
    const { data } = yield call(api.get, `/calls/open`);
    if (!!data.id) {
      yield put(AtendimentoActions.setAtendimento(data));
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* iniciaAtendimento({ payload }) {
  try {
    const { data } = yield call(api.post, `/calls`, payload);
    yield put(BuscaClienteActions.buscaClienteAction(payload.cpf_cnpj));
    yield put(AtendimentoActions.setAtendimento(data));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* finalizaAtendimento({ payload }) {
  try {
    const { data } = yield call(api.put, `/calls/${payload.id}`, payload);
    const { atendimento } = yield select(state => state.atendimento);
    if (data.campaign_id) {
      yield put(BuscaClienteActions.sorteiaCliente(data.campaign_id));
    } else {
      yield put(
        BuscaClienteActions.buscaClienteAction(atendimento.customer.cpf_cnpj)
      );
    }
    yield put(AtendimentoActions.setAtendimento({}));
    yield put(
      SuccessActions.openSuccess("Atendimento finalizado com sucesso.")
    );
    yield put(AgendamentosActions.getAgendamentos());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}



// WEBPACK FOOTER //
// ./src/store/sagas/atendimento.js